import { NavLink } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from './logo.png';
import { useAuth } from './components/auth/AuthProvider';
import { NavDropdown } from "react-bootstrap";

export function Navigation() {
  const { token, allowedSections, onLogout } = useAuth();
  const protectedLinks = allowedSections.map((item, i) => <Nav.Link href={item.path} key={`protected-${i}`}>{item.title}</Nav.Link>);

  if (protectedLinks.length) {
    protectedLinks.push(
      <Nav.Link href='/servicios'>Servicios</Nav.Link>
    )
  }

  return (
    <Navbar collapseOnSelect expand="lg">
      <Container>
      <Navbar.Brand href="/"><img width={160} height='auto' src={logo} alt="Logo FAMA" /></Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <NavLink to="/" className="nav-link">Inicio</NavLink>
            <NavLink to="/ecn" className="nav-link">Equipo Coordinador Nacional</NavLink>
            <NavLink to="/presencia" className="nav-link">Presencia</NavLink>
            <NavLink to="/servicios" className="nav-link">Servicios</NavLink>
          </Nav>
          <Nav>
            { !!protectedLinks.length && <NavDropdown title="Plataforma">{protectedLinks}</NavDropdown> }
            
            {token && <>
              <NavLink to="/app/user" className="nav-link">Editar perfil</NavLink>
              <NavLink onClick={onLogout} to="/signout" className="nav-link">Cerrar Sesión</NavLink>
            </>}
            {!token && <>
              <NavLink to="/login" className="nav-link">Inicia Sesión</NavLink>
              <NavLink to="/registro" className="nav-link">Registro</NavLink>
            </>}
          </Nav>
          <Nav>
            {/* <FamaPaypalDonate /> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}